!customElements.get('hoculus-article-zoom') &&
    customElements.define('hoculus-article-zoom', class extends HTMLElement {
        /* 
        CONFIG EXAMPLE
        {
            "modalId": string,
            "modalName": string,
            "gridId": string,
            "holderId": string
        }
        */

        constructor() {
            super();
        }

        connectedCallback() {
            this.boundInitFn = this.init.bind(this);
            window.addEventListener('DOMContentLoaded', this.boundInitFn);
            
            this.config = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent ?? null);
        }

        init() {
            window.removeEventListener('DOMContentLoaded', this.boundInitFn);

            this.modal = new theme.Modals(this.config.modalId, this.config.modalName);

            const articlesGrid = document.getElementById(this.config.gridId)

            articlesGrid.addEventListener('click', evt => {
                if (evt.target.tagName !== 'IMG') return;

                this.updateModalContent(evt.target);

                this.modal.open();
            })
        }

        updateModalContent(img) {
            const template = img.closest('[data-article]').querySelector('template')
            const content = template?.content.cloneNode(true);

            const holder = document.getElementById(this.config.holderId)
            holder.innerHTML = '';
            holder.appendChild(content);
        }
    });